  import React, { useState, useEffect, useContext } from 'react';
  import axios from 'axios';
  import Cookies from 'js-cookie'

  import Dropdown from '../common/Dropdown'

  // import LOAD_CHAR from '../Charsheet0/helpers/load_char2.js'
  import GET_DATA from '../Charsheet0/helpers/get_data.js'
  import LOCAL_BACKUP from '../Charsheet0/helpers/download-code.js'
  import getCharacterList from '../../helpers/getCharacterList.js';
  import uploadImage from '../../helpers/uploadImage.js'
  import ImageCropModal from '../common/ImageCropModal';

  import { UserDataContext } from "../../App.js";

  // ----------------------------------------------------------------------------------
  //                         Description
  //
  //     What does NavBarButton do?
  //
  //     (c) DXA Development 2023
  // ----------------------------------------------------------------------------------

  function CharactersButton(props) {

      // ------------ parameters ---------------

      // ------ inherited state variables ------
      let [currentChar, setChar] = props.state; // these are technically props.state[0] & props.state[1]
      const [userData, setUserData] = useContext(UserDataContext);
      const currentCampaign = userData.currentCampaign;
      const [activeView, setActiveView] = props.activeViewArray;
      const globalState = props.state;
      const layout = globalState[3];
      const setLayout = globalState[4];


      // -------- character data constants -------
      const basic_characters = ['Grok-Tar', 'Rae', 'Kendra', 'Welcome to ADM'];
      const blank_roll_save = ['blank', 'Upload Image', 'Roll New', 'Save Local Backup'];
      const separator = '---';



      // -------- local state variables --------
      const [characterList, setCharacterList] = useState(['blank', 'Roll New', 'Save Local Backup', separator, 'Grok-Tar', 'Rae', 'Kendra', 'Welcome to ADM']);
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [croppedImage, setCroppedImage] = useState(null);

      // -------- GET CHARACTER LIST -----------    
      
      // for now, just use the greyhawk characters by default
      let characters = [ ...basic_characters, separator, ...blank_roll_save ]; 
      
      // special list for Doc Sonic
      let docs_characters = ['Charles', 'Paul', separator,
                      'Martin', 'Edward the Enforcer', separator,
                      'Yarg Smashskull', 'Lanora Snugglebottom',  separator,
                      'Aeoni', 'Mavis',
                      separator,
                      'test', 'test2', separator,
                      // 'Eli', 'Trunk', 'Trea', 'Zum', 'Fonk', 'Gerthmig', 'Tonk', 'Davbin', separator, 
                      'Rygar', 'Sylonnus', 'Grok-Nar', separator,
                      'blank', 'Roll New', 'Save Local Backup'];
        

      useEffect( () => {

        async function getUniqueCharacterNames(array, username) {
            // Create Sets to store unique character names
            const uniqueNamesUser = new Set();
            const uniqueNamesOther = new Set();
            
            // First, collect names for the specified user
            array.forEach(item => {
              if (item.userName === username) {
                uniqueNamesUser.add(item.characterName);
              }
            });
            
            // Then, collect names for other users, excluding those in uniqueNamesUser
            array.forEach(item => {
              if (item.userName !== username && !uniqueNamesUser.has(item.characterName)) {
                uniqueNamesOther.add(item.characterName);
              }
            });

            // filter out special characters from uniqueNamesOther
            // any character name that starts with 'test' is a special character
            // any character name that starts with 'DM' is a private character
            // also any specifically listed in the array dontShowCharacters
            let dontShowCharacters = ['Sample Character','Sylonnus Transvexus', 'Grok-Nar', 'Rygar', 'Eli', 'Trunk', 'Trea', 'Zum', 'Fonk', 'Gerthmig', 'Tonk', 'Davbin'];
            let filteredUniqueNamesOther = Array.from(uniqueNamesOther).filter(name => !name.startsWith('test'));
            filteredUniqueNamesOther = filteredUniqueNamesOther.filter(name => !name.startsWith('DM-'));
            filteredUniqueNamesOther = filteredUniqueNamesOther.filter(name => !dontShowCharacters.includes(name));

            // Convert Sets to arrays and return as object
            return {
              uniqueNamesUser: Array.from(uniqueNamesUser),
              uniqueNamesOther: Array.from(filteredUniqueNamesOther)
            };
          }

        async function getCharacterListMain () {

            let characterListNew = await getCharacterList(userData)
            
            // insert 'Upload Image' before the last entry in characterListNew
            characterListNew.splice(characterListNew.length - 2, 0, 'Upload Image');

            setCharacterList( characterListNew)
        }

        getCharacterListMain();

      }, [userData] ); //useEffect
      

      // ---------- image handler functions ----------

      const handleImageUpload = async (image) => {

        uploadImage( image, currentChar, currentCampaign )

  };

  const handleImageClose = () => {
      setIsModalOpen(false);
  };

  const handleImageComplete = (croppedData) => {

      handleImageUpload(croppedData)

          const imageURL = URL.createObjectURL(croppedData);
          setCroppedImage(imageURL);
          setIsModalOpen(false);
          // process croppedData as needed
          console.log('Cropped image data:', croppedData);
        };


      // ---------- event handlers -------------
      const handleMenu = (selection) => {

          // the final selection item is search
          console.log(selection, characterList[selection]);
          console.log(characterList)
          if ( characterList[selection] === 'Roll New' ) { 
            setActiveView('charsheet')
            setChar('');
            setTimeout(() => {
                setChar('random');
                }, 0);

            if ( ! userData.loggedIn) { 
              alert('To save, log in: Settings > Log In\n\nthen: Load/Save > Save');
            }

            return;
          }

          else if ( characterList[selection] === 'Upload Image' ) {
            if ( currentChar !== Cookies.get('currentChar')) {
              alert('Save character before uploading image')
              return;
            }
            if (userData.loggedIn) {
            setIsModalOpen(true);
            } else {
              alert('Log in and save character to save image\n\nSettings > Log In')}
            return;
          }
          
          // for ALL OTHER SELECTIONS - LOAD THE CHARACTER
          else {
            
            // ---------- SAVE LOCAL BACKUP ------------
            if ( characterList[selection] === 'Save Local Backup' ) {

              var outputfile = prompt("Character will be saved to json file on your device. Can be uploaded later by GM in case of emergency.\nEnter filename:", currentChar );
                  if (outputfile === null || outputfile === "") {
                      let txt = "User cancelled the prompt.";
                      console.log(txt); }
                  else {
                      let chardata = {};
                      chardata.name = currentChar;
                      chardata.version = 0.4;
                      chardata.chardata = GET_DATA();
                      console.log('chardata: ', chardata.chardata);
                      chardata.name = currentChar;
                      outputfile = outputfile + ".JSON"
                      LOCAL_BACKUP(JSON.stringify(chardata, null, '\t'), outputfile, 'text/json')
                  }
            }
            
            // ---------- CHARACTER SELECTED ------------
            else if ( characterList[selection] !== separator)  {
              // LOAD_CHAR(characters[selection], setChar, false);
              console.log('SET CHAR button click')
              if (currentChar === characterList[selection] ) {
                setActiveView('charsheet')  
              }
              if ( characterList[selection].startsWith('DM-M')) {
                  setLayout('mobile-DM')
              } else {
              if (layout==='mobile-DM') { setLayout('mobile')}
              }
              setChar(characterList[selection]);
            }
          }
        }

        const handleFuture = () => {
          alert('Future feature');
        }

        
      // ---------- return html (jsx) ----------
      return (
          <>
          <Dropdown
              trigger = {<button id="nav-menu-characters" className="nav-menu-button">Characters</button>}
              menu = { characterList.map ( ( character, idx) => 
                  { return <button onClick={()=>handleMenu(idx)}>{character}</button>}
              )}
              divClass='navbaritem'
              menuClass='menu character-menu'  
          />
          {isModalOpen && (
              <ImageCropModal
                id='image-crop-modal'
                isOpen={isModalOpen}
                onSave={handleImageComplete}
                onClose={handleImageClose}
                isMobile={layout.includes('mobile')}
              />
          )}
          </>
      )

      };  // end of function

      export default CharactersButton